import { useQuery } from 'react-query';
import AuthService from '~/api/services/auth';
import ProfileService from '~/api/services/profile';
import { onError } from '~/utils/helpers';

const getNotificationCount = () => useQuery(
  'notifications-count',
  () => ProfileService.getNotificationCount(),
  {
    cacheTime: 60000,
    enabled: true,
    refetchOnMount: true,
    refetchOnWindowFocus: false,
    refetchInterval: 10000,
    retry: 1,
    onError,
    select: (data) => {
      return data.data
    }
  }
)

const getNewNotifications = (enabled) => useQuery(
  'new-notifications-list',
  () => ProfileService.getNewNotifications(),
  {
    cacheTime: 60000,
    enabled: enabled,
    refetchOnMount: false,
    refetchOnWindowFocus: false,
    retry: 1,
    onError,
    select: (data) => {
      return data.data
    }
  }
)

const getNotifications = (data) => useQuery(
  'notifications-list',
  () => ProfileService.getNotifications(data),
  {
    cacheTime: 60000,
    enabled: true,
    refetchOnMount: false,
    refetchOnWindowFocus: false,
    retry: 1,
    onError,
    select: (data) => {
      return data.data
    }
  }
)

const getCountriesList = (isSwissDairy) => useQuery(
  'countries-list',
  () => isSwissDairy && AuthService.getCountriesList(),
  {
    cacheTime: 60000,
    enabled: true,
    refetchOnMount: false,
    refetchOnWindowFocus: false,
    retry: 1,
    onError,
    select: (data) => {
      return data?.data
    }
  }
)

export const ProfileQuery = {
  getNotificationCount,
  getNotifications,
  getNewNotifications,
  getCountriesList
};